import { createSlice } from '@reduxjs/toolkit';

import { getReferralLink } from 'thunks';

export interface ReferralLinkState {
  referralLink?: string;
  isLoading: boolean;
}

const initialState: ReferralLinkState = {
  isLoading: false,
};

const referralLink = createSlice({
  name: 'referralLink',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReferralLink.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getReferralLink.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.referralLink = payload.referralLink || undefined;
    });

    builder.addCase(getReferralLink.rejected, (state) => {
      state.isLoading = false;
      state.referralLink = undefined;
    });
  },
});

export default referralLink.reducer;
